import { render, staticRenderFns } from "./newFooter.vue?vue&type=template&id=70badb35"
import script from "./newFooter.vue?vue&type=script&lang=js"
export * from "./newFooter.vue?vue&type=script&lang=js"
import style0 from "./newFooter.vue?vue&type=style&index=0&id=70badb35&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports